// src/components/SmartFlow/SmartFlow.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import WorkflowsList from "./WorkflowsList";
import WorkflowBuilder from "./WorkflowBuilder";
import "./SmartFlow.css";

const SmartFlow = () => {
  return (
    <div className="smartflow-container">
      <Routes>
        {/* "/smartflow"  => lista */}
        <Route index element={<WorkflowsList />} />

        {/* "/smartflow/builder" */}
        <Route path="builder" element={<WorkflowBuilder />} />

        {/* "/smartflow/builder/123" */}
        <Route path="builder/:id" element={<WorkflowBuilder />} />
      </Routes>
    </div>
  );
};

export default SmartFlow;
